import modal from "./index"

export default {
    install(app) {
        app.component('Modal', modal)
    }
}
